import {
  ILprGroupCreateProps,
  ILprGroupProps,
  ILprGroupSimpleProps,
  ILprGroupUpdateParams,
} from './types';
import { api } from '../DefaultService';

const ENDPOINT = 'v1/lprGroup';

export const createLprGroupAsync = async (
  data: ILprGroupCreateProps,
): Promise<ILprGroupProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getLprGroupByIdAsync = async (
  id: number,
): Promise<ILprGroupProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllLprGroupByLicenseAsync = async (): Promise<
  ILprGroupSimpleProps[]
> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateLprGroupAsync = async ({
  id,
  data,
}: ILprGroupUpdateParams): Promise<ILprGroupProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteLprGroupAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
